import { GlPopover, GlLink } from '@gitlab/ui';
import HelpIcon from '~/vue_shared/components/help_icon/help_icon.vue';
export default {
    name: 'EmptyRuleApprovers',
    components: {
        GlPopover,
        GlLink,
        HelpIcon
    },
    props: {
        eligibleApproversDocsPath: {
            type: String,
            required: false,
            default: ''
        },
        popoverId: {
            type: String,
            required: false,
            default: 'pop-approver'
        },
        popoverContainerId: {
            type: String,
            required: false,
            default: 'popovercontainer'
        }
    }
};
